import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { PaginationOffset } from "./PaginationOffset";

interface Props {
  limit: number;
  setLimit: any;
  props: any;
  offset: any;
  setOffset: any;
  total: any;
  display?: "ROW" | "FLEX";
  small?: boolean;
  count?: number;
}

export function Pagination({ props, offset, setOffset, total, display, limit, setLimit, small, count }: Props) {
  const { location, replace } = useHistory();
  const query = new URLSearchParams(location.search);

  useEffect(() => {
    if (!query.get("limit")) {
      query.append("limit", limit ? limit.toString() : "10");
      replace({
        pathname: location.pathname,
        search: query.toString(),
      });
    }
    setLimit(query.get("limit"));
  }, [location, query, replace, setLimit, limit]);

  return (
    <div
      className={display !== "FLEX" ? "row" : ""}
      style={{
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
        fontSize: small ? 12 : 14,
      }}
    >
      <div className={display !== "FLEX" ? "col-sm-6" : ""}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <select
            className={small ? "lf-form-control form-control-sm" : "form-control form-control-sm"}
            style={{ width: 60, marginLeft: 5, marginRight: 5 }}
            value={limit}
            onChange={(e) => {
              setLimit(e.target.value);
              query.set("limit", e.target.value);
              replace({
                pathname: location.pathname,
                search: query.toString(),
              });
            }}
          >
            <option value="10">10</option>
            <option value="30">30</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
          {total && (
            <span>
              Showing {offset * Number(query.get("limit")) + 1} to{" "}
              {total < (offset + 1) * Number(query.get("limit")) ? total : (offset + 1) * Number(query.get("limit"))}{" "}
              {total && `of ${total} entries`}
            </span>
          )}
        </div>
      </div>
      <div className={display !== "FLEX" ? "col-sm-6" : ""}>
        <PaginationOffset {...props} onPage={(e: any) => setOffset(e - 1)} count={count} />
      </div>
    </div>
  );
}
